'use strict';

/**
 * SQLite datetime('now') stores UTC without timezone indicator: "2026-04-01 00:03:35"
 * JavaScript new Date("2026-04-01 00:03:35") parses it as LOCAL time → wrong diff.
 * We normalize it to an ISO string with Z suffix to force UTC interpretation.
 */
export function parseDate(d) {
  if (!d) return null;
  // Already has timezone info (ISO 8601 with T and Z or +HH:MM)
  if (d.includes('T')) return new Date(d);
  // SQLite format "YYYY-MM-DD HH:MM:SS" → treat as UTC
  return new Date(d.replace(' ', 'T') + 'Z');
}

/**
 * Returns a human-readable relative string ("hace 5m", "hace 2h") or a
 * localized date string for older dates.
 */
export function timeAgo(d) {
  const dt = parseDate(d);
  if (!dt) return '—';
  const diff = (Date.now() - dt.getTime()) / 1000;
  if (diff < 60)    return 'ahora mismo';
  if (diff < 3600)  return 'hace ' + Math.floor(diff / 60) + 'm';
  if (diff < 86400) return 'hace ' + Math.floor(diff / 3600) + 'h';
  return dt.toLocaleDateString('es-ES', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

/**
 * Formats a date as a short localized string (no time).
 */
export function fmtDate(d) {
  const dt = parseDate(d);
  if (!dt) return '—';
  return dt.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
}

/**
 * Formats a date with time.
 */
export function fmtDateTime(d) {
  const dt = parseDate(d);
  if (!dt) return '—';
  return dt.toLocaleDateString('es-ES', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

/**
 * Returns human-readable duration between two dates.
 * e.g. "3h 20m", "2d 4h", "45m"
 */
export function duration(from, to) {
  const a = parseDate(from);
  const b = parseDate(to || new Date().toISOString());
  if (!a || !b) return '—';
  const secs = Math.max(0, (b.getTime() - a.getTime()) / 1000);
  if (secs < 60)     return Math.round(secs) + 's';
  if (secs < 3600)   return Math.floor(secs / 60) + 'm';
  if (secs < 86400) {
    const h = Math.floor(secs / 3600);
    const m = Math.floor((secs % 3600) / 60);
    return m ? `${h}h ${m}m` : `${h}h`;
  }
  const days = Math.floor(secs / 86400);
  const h    = Math.floor((secs % 86400) / 3600);
  return h ? `${days}d ${h}h` : `${days}d`;
}
